(function () {
  var mobileQuery = window.matchMedia('(max-width: 767px)');

  function initTrack(track) {
    if (!track || track.dataset.productCardSwipeReady === 'true') return;

    var media = track.closest('.all-pieces-card__media');
    var dots = media ? Array.prototype.slice.call(media.querySelectorAll('[data-product-card-dot]')) : [];
    var pointerId = null;
    var startX = 0;
    var startY = 0;
    var dragged = false;
    var suppressClick = false;
    var frame = null;

    function updateDots() {
      frame = null;
      if (!dots.length || !track.clientWidth) return;

      var activeIndex = Math.max(0, Math.min(dots.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    }

    track.addEventListener('scroll', function () {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(updateDots);
    }, { passive: true });

    track.addEventListener('pointerdown', function (event) {
      if (!mobileQuery.matches || !event.isPrimary || event.button !== 0) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      dragged = false;
      suppressClick = false;
    }, { passive: true });

    track.addEventListener('pointermove', function (event) {
      if (pointerId !== event.pointerId) return;

      var deltaX = Math.abs(event.clientX - startX);
      var deltaY = Math.abs(event.clientY - startY);
      if (deltaX > 8 && deltaX > deltaY) {
        dragged = true;
      }
    }, { passive: true });

    track.addEventListener('pointerup', function (event) {
      if (pointerId !== event.pointerId) return;
      suppressClick = dragged;
      pointerId = null;
    }, { passive: true });

    track.addEventListener('pointercancel', function () {
      pointerId = null;
      dragged = false;
    }, { passive: true });

    track.addEventListener('click', function (event) {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressClick = false;
      dragged = false;
    });

    track.dataset.productCardSwipeReady = 'true';
    updateDots();
  }

  function init(scope) {
    if (!mobileQuery.matches) return;
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-product-card-swipe]'), initTrack);
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', function (event) {
      if (event.matches) init(document);
    });
  }
}());
